import { IDocumentItem } from '../../models/common/document-item.model';
import { ICompareAlternativesPage } from '../../models/compare-alternatives/compare-alternatives.model';
import { IPLPPricesItem } from '../../models/plp/product-list-page.model';
import { IBasketService } from '../../services/basket/basket-service';
import { IPLPService } from '../../services/plp/plp-service';
import { IPricingService } from '../../services/pricing/pricing-service';
import { IPricesResult } from '../../services/pricing/pricing.dto';
import { IProductService } from '../../services/product/product-service';
import { IGetDataSheetsResult } from '../../services/product/product.dto';

export type CompareAlternativesProps = {
  data: ICompareAlternativesPage;
  basketService: IBasketService;
  plpService?: IPLPService; //TODO: check whether required or not
  pricingService: IPricingService;
  productService: IProductService;
};

export type State = {
  quantity: number;
  isValidQty: boolean;
  isBusy: boolean;
  prices?: IPLPPricesItem[];
  dataSheets?: { [stockCode: string]: IDocumentItem[] };
};

export type Action =
  | { type: CompareAlternativesActionType.SetIsValidQty; isValid: boolean; quantity: number }
  | { type: CompareAlternativesActionType.IsBusy; isBusy: boolean }
  | { type: CompareAlternativesActionType.SetPriceData; data: IPricesResult }
  | { type: CompareAlternativesActionType.SetDataSheets; stockCode: string; data: IGetDataSheetsResult };

export enum CompareAlternativesActionType {
  SetIsValidQty = 'SetIsValidQty',
  IsBusy = 'IsBusy',
  SetPriceData = 'SetPriceData',
  SetDataSheets = 'SetDataSheets',
}
